var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4716 4.02827C10.7319 4.28862 10.7319 4.71073 10.4716 4.97108L6.94297 8.49967L10.4716 12.0283C10.7319 12.2886 10.7319 12.7107 10.4716 12.9711C10.2112 13.2314 9.78911 13.2314 9.52876 12.9711L5.52876 8.97108C5.26841 8.71073 5.26841 8.28862 5.52876 8.02827L9.52876 4.02827C9.78911 3.76792 10.2112 3.76792 10.4716 4.02827Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft1);
export default __webpack_public_path__ + "static/media/chevron-left1.6acd61c57e757d257992186a35d7e341.svg";
export { ForwardRef as ReactComponent };